import {FC, useEffect} from "react";
import {registerLocale} from "react-datepicker";
import DatePicker from "react-datepicker";

import ru from "date-fns/locale/ru";

import "react-datepicker/dist/react-datepicker.css";
import styles from "../headerBtn.module.scss";
import Select from "../../custom/select/select";

interface ICopyReportProps {
    selectedDate: Date | null;
    withGeolocations: boolean;
    setWithGeolocations: (checked: boolean) => void;
    setSelectedDate: (date: Date | null) => void;
}

const CopyReportSection: FC<ICopyReportProps> = ({
                                                     setSelectedDate,
                                                     selectedDate,
                                                     withGeolocations,
                                                     setWithGeolocations
                                                 }) => {
    useEffect(() => {
        registerLocale("ru", ru);
    }, []);

    const handleDatePickerChange = (date: Date) => {
        setSelectedDate(date);
    };

    const handleClearDate = () => {
        if (selectedDate) {
            setSelectedDate(null);
        }
    };

    const booleanOptions = [
        {value: true, label: "Да"},
        {value: false, label: "Нет"},
    ];

    return (
        <div className={styles.copy__block}>
            <div>
                <span className={styles.copy__report_title}>Дата копирования:</span>
                <div className={styles.copy__data_picker}>
                    <DatePicker
                        dateFormat="dd.MM.yyyy"
                        placeholderText="Выберите дату"
                        selected={!selectedDate ? new Date() : selectedDate}
                        locale={ru}
                        name="date"
                        onChange={handleDatePickerChange}
                    />
                    {selectedDate && (
                        <div className={styles.clear__date_icon} onClick={handleClearDate}/>
                    )}
                </div>
            </div>
            <div>
                <span className={styles.copy__report_title}>Копировать геолокацию:</span>
                <div>
                    <Select
                        options={booleanOptions}
                        propsChange={(event: { value: boolean; label: string }) =>
                            setWithGeolocations(event.value)
                        }
                        className="users__filter"
                        name="geolocations"
                        defaultValue={{value: true, label: "Да"}}
                    />
                </div>
            </div>
        </div>
    );
};

export default CopyReportSection;
